import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.up = {
      transition: 'opacity 0.15s ease-in-out',
      width: '20px',
      cursor: 'pointer',
      position: 'absolute',
      bottom: 'calc(100% + 12px)',
      left: '50%',
      transform: 'translateX(-50%)',
    };

    this.down = {
      transition: 'opacity 0.15s ease-in-out',
      width: '20px',
      cursor: 'pointer',
      position: 'absolute',
      top: 'calc(100% + 12px)',
      left: '50%',
      transform: 'translateX(-50%)',
    };
  })()
);
